import { CheckCircle2, Info, X, XCircle } from 'lucide-react';
import { createPortal } from 'react-dom';
import { useUi } from '../../store/ui';

/** Toast host. Mounted once in App; reads from the ui store. */
export function Toasts() {
  const { toasts, dismiss } = useUi();
  if (!toasts.length) return null;

  const icons = {
    success: <CheckCircle2 className="h-5 w-5 text-emerald-500" />,
    error: <XCircle className="h-5 w-5 text-red-500" />,
    info: <Info className="h-5 w-5 text-sky-500" />,
  };

  return createPortal(
    <div className="pointer-events-none fixed inset-x-0 bottom-20 z-[60] flex flex-col items-center gap-2 px-4 sm:bottom-4 sm:items-end sm:px-6" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className="pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-xl border border-line bg-surface-1 p-3 shadow-pop animate-fade-in">
          <span className="mt-0.5 shrink-0">{icons[t.kind]}</span>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-ink">{t.title}</p>
            {t.message && <p className="mt-0.5 break-words text-xs text-ink-muted">{t.message}</p>}
          </div>
          <button onClick={() => dismiss(t.id)} className="rounded p-1 text-ink-faint hover:bg-surface-2 hover:text-ink" aria-label="Dismiss">
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>,
    document.body,
  );
}
